(function megaMenuOpenOnHover() {
  const mega = document.querySelectorAll("header-menu details.mega-menu");
  if (!mega.length) return;

  const CLOSE_DELAY = 75;

  mega.forEach((item) => {
    let closeTimer = null;

    const open = () => {
      if (closeTimer) clearTimeout(closeTimer);
      item.setAttribute("open", "");
    };

    const scheduleClose = () => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(() => item.removeAttribute("open"), CLOSE_DELAY);
    };

    item.addEventListener("mouseenter", open);
    item.addEventListener("mouseleave", scheduleClose);

    const panel = item.querySelector(".mega-menu__content");
    if (panel) {
      panel.addEventListener("mouseenter", open);
      panel.addEventListener("mouseleave", scheduleClose);
    }
  });
})();
